module.exports = __webpack_public_path__ + "img/capgemini.f49c7343.svg";